import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/certificates.css";

function CertificatesPage() {
  const { t } = useTranslation();

  const certificates = [
    {
      id: "responsive-web-design",
      title: "Responsive Web Design",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "Frontend",
      statusClass: "status-done",
      link: "https://freecodecamp.org/certification/danilturasov/responsive-web-design-v9",
      skills: ["HTML5", "CSS3", "Flexbox", "CSS Grid", "Responsive Design", "Accessibility"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      )
    },
    {
      id: "javascript-algorithms",
      title: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "JavaScript",
      statusClass: "status-done",
      link: "https://www.freecodecamp.org/certification/danilturasov/javascript-v9",
      skills: ["ES6+", "Algorithms", "Data Structures", "OOP", "Functional Programming"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"/>
          <polyline points="8 6 2 12 8 18"/>
        </svg>
      )
    },
    {
      id: "frontend-libraries",
      title: "Front End Development Libraries",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "Libraries",
      statusClass: "status-done",
      link: "https://www.freecodecamp.org/certification/danilturasov/front-end-development-libraries-v9",
      skills: ["React.js", "Redux", "Bootstrap", "SASS / SCSS", "jQuery", "UI Components"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="12 2 2 7 12 12 22 7 12 2"/>
          <polyline points="2 17 12 22 22 17"/>
          <polyline points="2 12 12 17 22 12"/>
        </svg>
      )
    },
    {
      id: "backend-apis",
      title: "Back End Development and APIs",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "Backend",
      statusClass: "status-done",
      link: "https://freecodecamp.org/certification/danilturasov/back-end-development-and-apis-v9",
      skills: ["Node.js", "Express.js", "MongoDB", "Mongoose", "REST APIs", "NPM"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
          <line x1="6" y1="6" x2="6.01" y2="6"/>
          <line x1="6" y1="18" x2="6.01" y2="18"/>
        </svg>
      )
    },
    {
      id: "relational-databases",
      title: "Relational Databases",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "Databases",
      statusClass: "status-done",
      link: "https://freecodecamp.org/certification/danilturasov/relational-databases-v9",
      skills: ["PostgreSQL", "SQL", "Database Architecture", "Bash Scripting", "Git CLI"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="5" rx="9" ry="3"/>
          <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
          <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
        </svg>
      )
    },
    {
      id: "scientific-computing-python",
      title: "Scientific Computing with Python",
      issuer: "freeCodeCamp.org",
      hours: "300 hours",
      category: "Python",
      statusClass: "status-done",
      link: "https://freecodecamp.org/certification/danilturasov/python-v9",
      skills: ["Python 3", "Data Structures", "Algorithms", "OOP in Python", "Regex"],
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="4 17 10 11 4 5"/>
          <line x1="12" y1="19" x2="20" y2="19"/>
        </svg>
      )
    }
  ];

  return (
    <section id="certificates" className="section reveal certificates-section">
      <div className="certificates-container">
        
        {/* Section Header */}
        <div className="certificates-header">
          <h2 className="gradient-text">
            {t("about.certificates_heading", "My Certifications")}
          </h2>
          <p>
            {t("about.certificates_subtitle", "Official certifications earned from freeCodeCamp verifying 1,800+ hours of coursework and real-world project development.")}
          </p>
        </div>

        {/* Certificates Bento Grid */}
        <div className="certificates-grid">
          {certificates.map((cert) => (
            <div key={cert.id} className="bento-card certificate-bento-card">
              
              {/* Card Top: Icon & Status Badge */}
              <div className="certificate-card-top">
                <div className="certificate-icon-box">
                  {cert.icon}
                </div>
                <span className={`roadmap-status-badge ${cert.statusClass}`}>
                  {cert.category}
                </span>
              </div>

              {/* Card Content: Title & Details */}
              <div className="certificate-card-content">
                <h4 className="certificate-card-title">{cert.title}</h4>
                <span className="certificate-card-subtitle">
                  {cert.issuer} • {cert.hours}
                </span>

                {/* Skill Tags */}
                <div className="certificate-tags-wrap">
                  {cert.skills.map((skill, idx) => (
                    <span key={idx} className="certificate-tag">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Action Button */}
              <a
                href={cert.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary certificate-verify-button"
              >
                <span>{t("about.certificates_verify", "Verify Credential")}</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </a>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default CertificatesPage;
